import { render, staticRenderFns } from "./TemplateGapNote.vue?vue&type=template&id=16d408d0&scoped=true"
import script from "./TemplateGapNote.vue?vue&type=script&lang=js"
export * from "./TemplateGapNote.vue?vue&type=script&lang=js"
import style0 from "./TemplateGapNote.vue?vue&type=style&index=0&id=16d408d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16d408d0",
  null
  
)

export default component.exports